import axios from "axios";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_PATH,
});

const token = localStorage.getItem("accessToken");

if (token) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
}

apiClient.interceptors.request.use(
  (config) => {
    config.params = {
      // api_token: localStorage.getItem("accessToken"),
      ...config.params,
    };
    
    return {
      ...config,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("accessToken"),
        ...config.headers,
      },
    };
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 401) {
      const hadToken = !!localStorage.getItem("accessToken");

      localStorage.removeItem("accessToken");
      localStorage.removeItem("userId");
      localStorage.removeItem("userName");
      localStorage.removeItem("userEmail");
      localStorage.removeItem("tokenExpiry");
      localStorage.removeItem("loginTimestamp");

      // Only hard-redirect if the user was authenticated (expired/revoked token).
      // For public auth endpoints (login, verify-2fa), let the component handle the error.
      if (hadToken) {
        window.location.replace("/");
      }
    }
    return Promise.reject(error.response?.data);
  }
);

const { get, post, put, delete: destroy, patch } = apiClient;
export { get, post, put, destroy, patch };